@if (image) {
  <div class="image">
    <img [src]="image" />
  </div>
}
<div class="value" [class.no-image]="!image">
  @if (isLabelVisible) {
    <label>{{ label }}</label>
  }
  @if (!customContent.hasChildNodes()) {
    <span [style]="valueStyle" [ngClass]="valueClass">
      @switch (valueType) {
        @case (ValueType.CURRENCY) {
          {{ value ? (value | currency: "GBP" : "symbol" : "1.0-0") : "-" }}
        }
        @case (ValueType.PERCENTAGE) {
          {{ value ? (value | percent: "1.2-2") : "-" }}
        }
        @case (ValueType.TEXT) {
          {{ value ?? "-" }}
        }
      }
      @if (value && valueSuffix) {
        {{ valueSuffix }}
      }
    </span>
  }
  <div class="custom-content" [style]="valueStyle" #customContent>
    <ng-content />
  </div>
</div>
